import {usePlusLoadExpected} from '@hconnect/tuc-processes/fields/plusLoad/usePlusLoadExpected'
import {Typography, Box, Switch} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

/**
 * Toggle component for the Plus Load field
 * Allows users to indicate whether a plus load is expected
 * Designed to match Figma specifications with proper toggle switch
 */
export const PlusLoadToggle: React.FC = () => {
  const {t} = useTranslation()
  const {plusLoad, setPlusLoad, enabled} = usePlusLoadExpected()

  // If the feature is not enabled, don't render anything
  if (!enabled) {
    return null
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          color: '#29333d',
          textAlign: 'left'
        }}
      >
        {t('orderIntake.rmc.steps.quantity.plusLoadQuestion', 'Do you need a plus load?')}
      </Typography>

      <Switch
        checked={plusLoad}
        onChange={(event) => setPlusLoad(event.target.checked)}
        sx={{
          width: 44,
          height: 24,
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: '2px',
            transitionDuration: '300ms',
            '&.Mui-checked': {
              transform: 'translateX(20px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: '#016ad4',
                opacity: 1,
                border: 0
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
              }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: '#016ad4',
              border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
              color: '#f5f5f5'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.3
            }
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 20,
            height: 20,
            boxShadow: '0px 3px 1px rgba(0,0,0,0.06), 0px 3px 8px rgba(0,0,0,0.15)'
          },
          '& .MuiSwitch-track': {
            borderRadius: 12,
            backgroundColor: '#d1d9e0',
            opacity: 1,
            transition: 'background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
          }
        }}
        data-test-id="rmc-plus-load-toggle"
      />
    </Box>
  )
}
